// Referência de uma cor é por tecido só quando há exceção — a maioria dos tecidos usa
// a `ref` padrão da cor. `color.refByCloth` ([{cloth, ref}]) guarda só os tecidos onde o
// fornecedor usa um código diferente; sem exceção pra esse tecido, cai na `ref` padrão.
function getRefForCloth(color, clothId) {
    const normalizedClothId = (!clothId || clothId === 'none') ? null : (clothId._id || clothId)
    if (!normalizedClothId) return color?.ref || ''
    const entries = color?.refByCloth || []
    const entry = entries.find((e) => (e.cloth?._id || e.cloth) === normalizedClothId)
    return entry ? (entry.ref || '') : (color?.ref || '')
}

export default getRefForCloth
